var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 809,
    height: 720,
    viewBox: "0 0 809 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.181 351.944C427.868 444.053 629.556 391.702 721.665 235.014L927 355.721C768.227 625.811 420.565 716.052 150.475 557.279L271.181 351.944Z",
    fill: "#FFE0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.282 321.285V498.675H654.658V328.578L375.876 336.435L230.533 187.85L106.282 321.285ZM200.699 254.473C200.699 246.604 203.845 239.057 209.446 233.493C215.046 227.929 222.641 224.803 230.561 224.803C238.481 224.803 246.077 227.929 251.677 233.493C257.278 239.057 260.424 246.604 260.424 254.473V296.875H200.699V254.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.424 254.463V296.865H200.69V254.463C200.69 250.567 201.462 246.709 202.963 243.109C204.463 239.509 206.663 236.239 209.436 233.484C212.209 230.728 215.501 228.543 219.124 227.052C222.747 225.561 226.63 224.793 230.552 224.793C234.473 224.793 238.357 225.561 241.98 227.052C245.603 228.543 248.895 230.728 251.668 233.484C254.441 236.239 256.64 239.509 258.141 243.109C259.642 246.709 260.414 250.567 260.414 254.463H260.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.492 447.211H605.792V365.108H572.492V447.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M572.492 383.495H605.792V365.108H572.492V383.495Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.701 447.211H470.302V365.108H403.701V447.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M403.701 383.495H470.302V365.108H403.701V383.495Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M230.562 224.793C232.702 224.799 234.836 225.033 236.926 225.49C230.272 226.933 224.314 230.593 220.042 235.863C215.769 241.133 213.439 247.696 213.438 254.463V296.865H200.699V254.463C200.699 250.567 201.472 246.709 202.972 243.109C204.473 239.51 206.673 236.239 209.446 233.484C212.219 230.728 215.511 228.543 219.134 227.052C222.757 225.561 226.64 224.793 230.562 224.793Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.832 498.665V314.886",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.282 330.112V498.666",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.682 498.674V336.434",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.416 176.049H230.561L85.2087 324.644V336.435H87.3966H96.0531H106.282V321.284L230.561 187.84L375.905 336.435L675.759 336.425L675.769 324.644L530.416 176.049Z",
    fill: "#DDDDDD",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.252 356.667H186.862V498.665H274.252V356.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.424 254.463V296.865H200.69V254.463C200.69 250.567 201.462 246.709 202.963 243.109C204.463 239.509 206.663 236.239 209.436 233.484C212.209 230.728 215.501 228.543 219.124 227.052C222.747 225.561 226.63 224.793 230.552 224.793V224.793C234.473 224.793 238.357 225.561 241.98 227.052C245.603 228.543 248.895 230.728 251.668 233.484C254.441 236.239 256.64 239.509 258.141 243.109C259.642 246.709 260.414 250.567 260.414 254.463H260.424Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.416 176.049H230.561L85.2087 324.644V336.425H106.282V321.284L230.561 187.84L375.905 336.425H675.759V324.644L530.416 176.049Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M274.252 356.667H186.862V369.324H274.252V356.667Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.759 498.666H89.6318",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.302 447.211H503.602V364.845H470.302V447.211Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 447.211H403.7V364.845H370.4V447.211Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.292 364.844H403.691V447.21H470.292V364.844Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.194 447.211H572.494V364.845H539.194V447.211Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.794 364.844H539.194V447.21H605.794V364.844Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.572 498.59V356.667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.74 296.865H187.373V314.509H273.74V296.865Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2731 469.221L43.7441 460.996C42.9063 458.313 42.6129 455.492 42.8807 452.695C43.1485 449.899 43.9722 447.183 45.3042 444.705C46.6362 442.227 48.4501 440.036 50.6405 438.26C52.8309 436.483 55.3543 435.157 58.0645 434.356C58.0498 428.077 59.7443 421.911 62.9689 416.51C66.1934 411.11 70.8278 406.677 76.3814 403.679C80.515 401.438 85.2007 400.4 89.9011 400.683C94.6014 400.966 99.1263 402.559 102.957 405.279L104.189 406.22C112.515 412.149 119.298 419.965 123.974 429.02C128.651 438.076 131.086 448.109 131.077 458.286C131.083 463.533 130.043 468.729 128.018 473.574C125.992 478.419 123.021 482.818 119.276 486.517C111.403 494.31 100.745 498.688 89.6317 498.693H86.2599C77.3007 498.667 68.5851 495.792 61.3896 490.489C54.194 485.185 48.8967 477.732 46.2731 469.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0642 434.356C58.0495 428.077 59.744 421.91 62.9686 416.51C66.1931 411.11 70.8276 406.676 76.3812 403.679C81.9433 400.637 88.4644 399.819 94.613 401.392C92.5893 401.929 90.6349 402.697 88.7884 403.679C83.2525 406.696 78.6333 411.134 75.413 416.53C72.1927 421.926 70.4893 428.083 70.4807 434.356C67.7724 435.16 65.2512 436.488 63.0625 438.265C60.8738 440.042 59.061 442.232 57.7287 444.709C56.3965 447.186 55.5712 449.9 55.3004 452.696C55.0296 455.491 55.3187 458.312 56.1511 460.996L58.6798 469.22C61.0845 477.003 65.7335 483.915 72.0512 489.1C78.3689 494.285 86.0781 497.515 94.2248 498.392C92.7238 498.544 91.2158 498.619 89.707 498.618H86.3353C77.3769 498.607 68.6568 495.75 61.449 490.464C54.2411 485.179 48.9235 477.741 46.2728 469.239L43.7439 461.015C42.9032 458.33 42.6076 455.507 42.874 452.708C43.1404 449.91 43.9634 447.192 45.2956 444.711C46.6278 442.231 48.4425 440.039 50.6344 438.261C52.8263 436.484 55.3519 435.156 58.0642 434.356Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2731 469.221L43.7441 460.996C42.9063 458.313 42.6129 455.492 42.8807 452.695C43.1485 449.899 43.9722 447.183 45.3042 444.705C46.6362 442.227 48.4501 440.036 50.6405 438.26C52.8309 436.483 55.3543 435.157 58.0645 434.356C58.0498 428.077 59.7443 421.911 62.9689 416.51C66.1934 411.11 70.8278 406.677 76.3814 403.679C80.515 401.438 85.2007 400.4 89.9011 400.683C94.6014 400.966 99.1263 402.559 102.957 405.279L104.189 406.22C112.515 412.149 119.298 419.965 123.974 429.02C128.651 438.076 131.086 448.109 131.077 458.286C131.083 463.533 130.043 468.729 128.018 473.574C125.992 478.419 123.021 482.818 119.276 486.517C111.403 494.31 100.745 498.688 89.6317 498.693H86.2599C77.3007 498.667 68.5851 495.792 61.3896 490.489C54.194 485.185 48.8967 477.732 46.2731 469.221Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.252 356.667H186.862V498.665H274.252V356.667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.802 447.211H639.102V364.845H605.802V447.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.802 447.211H639.102V364.845H605.802V447.211Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.713 199.922H486.679C516.145 199.923 545.323 194.158 572.546 182.954C599.769 171.75 624.504 155.328 645.338 134.625L645.973 133.994L617.247 104.625H762.599V253.211L731.79 221.753C666.674 286.138 578.545 322.282 486.679 322.281H375.867L230.786 176.242",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.713 199.922H486.679C516.145 199.923 545.323 194.158 572.546 182.954C599.769 171.75 624.504 155.328 645.338 134.625L645.973 133.994L617.247 104.625H762.599V253.211L731.79 221.753C666.674 286.138 578.545 322.282 486.679 322.281H375.867L230.786 176.242",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 809,
    height: 720,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/Boost.e87adcf1b65e51f6467d5ec91ac50c6f.svg";
export { ForwardRef as ReactComponent };